import React from "react";
import OfficerRegistration from "../components/auth/officerRegistration";

const OfficerSignup = () => {
  return <OfficerRegistration />;
};

export default OfficerSignup;
